import { render, staticRenderFns } from "./footerComponent.vue?vue&type=template&id=442e5009&scoped=true&"
import script from "./footerComponent.vue?vue&type=script&lang=js&"
export * from "./footerComponent.vue?vue&type=script&lang=js&"
import style0 from "./footerComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./footerComponent.vue?vue&type=style&index=1&id=442e5009&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e5009",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
